import clsx from "clsx";
import { Command } from "cmdk";
import * as selectStyles from "../common/Select.css";
import { Option } from "../common/SelectBase";

export interface SingleSelectListProps {
  /**
   *  Array of selectable item values
   */
  options: Option[];
  /**
   *  Callback when an item is selected
   */
  onOptionSelect: (option: Option) => void;
  /**
   * Currently selected option
   */
  selectedOption?: Option;
}

export function SingleSelectOptions({
  options,
  selectedOption,
  onOptionSelect
}: SingleSelectListProps): React.ReactElement {
  return (
    <>
      {options.map((option) => {
        const isSelected = selectedOption?.value === option.value;
        return (
          <Command.Item
            key={option.value}
            className={clsx(
              selectStyles.selectItem,
              isSelected && selectStyles.selectItemSelected
            )}
            onSelect={() => onOptionSelect(option)}
            aria-selected={isSelected}
            role="option"
            tabIndex={-1}
          >
            {option.label}
          </Command.Item>
        );
      })}
    </>
  );
}
